import { TableContainer, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import React from 'react';
import { CerebroLink, CerebroSecondaryButton } from '../../shared/components';
import { CurrentUser, DataRoomDiligenceRequest, DiligenceRequestFile, DiligenceRequestLink } from '../../shared/models';
import { DateUtils, FileUtils } from '../../shared/utils';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { DeleteRequestFileDialog } from './DeleteRequestFileDialog';
import { DeleteRequestLinkDialog } from './DeleteRequestLinkDialog';

interface RequestFileDisplayProps {
	dataRoomGuid: string | undefined;
	request: DataRoomDiligenceRequest | null;
	currentUser: CurrentUser;
}

export const RequestFileDisplay: React.FC<RequestFileDisplayProps> = ({ dataRoomGuid, request, currentUser }) => {
	const [deleteFile, setDeleteFile] = React.useState<DiligenceRequestFile | null>(null);
	const [deleteLink, setDeleteLink] = React.useState<DiligenceRequestLink | null>(null);

	const closeDrawersAndDialogs = () => {
		setDeleteFile(null);
		setDeleteLink(null);
	};

	return (
		<>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>File</TableCell>
							<TableCell>Date</TableCell>
							{!currentUser.isBankUser && <TableCell>Actions</TableCell>}
						</TableRow>
					</TableHead>
					<TableBody>
						{request?.files.map(file => {
							return (
								<TableRow key={file.guid}>
									<TableCell>
										<CerebroLink
											href={CerebroApiEndpoints.DataRoomDiligenceRequests.SpecificFileDownload(
												dataRoomGuid,
												request.guid,
												file.guid
											)}
											target="_blank"
											rel="noreferrer"
											variant="link"
										>
											{FileUtils.getFileTypeIcon(file.fileName)} {file.title}
										</CerebroLink>
									</TableCell>
									<TableCell>
										{DateUtils.FormatStringAsShortDate(file.createdOn.toString())}
									</TableCell>
									{!currentUser.isBankUser && (
										<TableCell>
											<CerebroSecondaryButton onClick={() => setDeleteFile(file)}>
												Delete
											</CerebroSecondaryButton>
										</TableCell>
									)}
								</TableRow>
							);
						})}
						{request?.links.map(link => {
							return (
								<TableRow key={link.guid}>
									<TableCell>
										<CerebroLink
											href={CerebroApiEndpoints.Documents.AbsoluteDownload(
												dataRoomGuid,
												link.document.guid
											)}
											target="_blank"
											rel="noreferrer"
											variant="link"
										>
											{FileUtils.getFileTypeIcon(link.document.fileName)} {link.document.name}
										</CerebroLink>
									</TableCell>
									<TableCell>
										{DateUtils.FormatStringAsShortDate(link.document.documentDate.toString())}
									</TableCell>
									{!currentUser.isBankUser && (
										<TableCell>
											<CerebroSecondaryButton onClick={() => setDeleteLink(link)}>
												Delete
											</CerebroSecondaryButton>
										</TableCell>
									)}
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>

			<DeleteRequestFileDialog
				dataRoomGuid={dataRoomGuid}
				request={request}
				file={deleteFile}
				currentUser={currentUser}
				close={closeDrawersAndDialogs}
			/>
			<DeleteRequestLinkDialog
				dataRoomGuid={dataRoomGuid}
				request={request}
				link={deleteLink}
				currentUser={currentUser}
				close={closeDrawersAndDialogs}
			/>
		</>
	);
};
